<template>
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      { 'no-scroll': isAppPage }
    ]"
  >
    <sdf-menu v-if="mainLayoutType === 'secureDataflow'"/>

    <v-nav-menu
      :navMenuItems="navMenuItems"
      parent=".layout--main"
      :version="version"
    />

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]"
    >
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark }
          ]"
        />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark }
          ]"
          :navMenuItems="navMenuItems"
        />
      </template>

      <template v-else-if="mainLayoutType === 'vertical'">
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark }
          ]"
        />
      </template>

      <template v-else-if="mainLayoutType === 'portMaster'"></template>

      <template v-else-if="mainLayoutType === 'secureDataflow'"></template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark }
          ]"
        />
      </template>
      <!-- /Navbar -->

      <!-- /Navbar -->
      <div class="content-wrapper">
        <div
          class="router-view"
          :class="{ 'mobile-router-view': isMobileDevice }"
        >
          <div class="router-content">
            <div
              id="humbuger-menu"
              v-if="isMobileDevice && !isSecureDataflow"
            >
              <a
                href="#"
                class="humbuger-menu-btn"
                @click.stop.prevent="toggleSidebar"
              >
                <img
                  src="@/assets/images/icons/lolcal/hamburger_menu.svg"
                  class="humbuger-menu-svg"
                />
              </a>
            </div>
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
                :class="{ 'mobile-router-header': isMobileDevice }"
              >
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-solid border-grey-light':
                      $route.meta.breadcrumb
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                />
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="
                    classesStr => $emit('setAppClasses', classesStr)
                  "
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer
        :version="version"
        :environment="environment"
        :isProduction="isProduction"
      />
    </div>



  </div>
</template>

<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";
import environment from "@/environment/aisea";
import SdfMenu from "@/layouts/components/vertical-nav-menu/secure-dataflow/Menu";
import { DeviceInfoMixin } from "@/mixins";

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    SdfMenu,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: navMenuItems,
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      version: environment.getVersion() || "0.0.0",
      environment: environment.getEnvironment(),
      isProduction: environment.isProduction(),
      layoutType: this.$route.meta.pageTitle,
      unsubscribe: () => {},
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      if (this.$route.meta.isSecureDataflow) {
        this.updateLayoutType("secureDataflow");
      } else {
        this.updateLayoutType("vertical");
      }
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    }
  },
  computed: {
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isMobileDevice() {
      // NOTE: 現状、ユーザエージェントでモバイル判定
      return ["iPhone", "iPad"].includes(this.getDeviceInfo().deviceType);
    },
    isSecureDataflow() {
      return this.$route.meta.isSecureDataflow;
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateLayoutType(layoutType) {
      this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", layoutType);
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 400)
      ) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    toggleSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
  },
  created() {
    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
  },
  mounted() {
    // 403Errorでトークン更新中にローディングを表示する
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === "auth/START_REFRESH_TOKEN") {
        this.$vs.loading();
      } else if (mutation.type === "auth/FINISH_REFRESH_TOKEN") {
        this.$vs.loading.close();
      }
    });
  },
  destroyed() {
    this.unsubscribe();
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#humbuger-menu {
  position: fixed;
  z-index: 2;
  top: 20px;
  left: 20px;

  @media screen and (max-width: $min-width-iphone-8) {
    top: 16px;
    left: 16px;
  }

  @media screen and (min-width: $min-width-iphone-11-pro) and (max-height: $min-width-iphone-8) {
    left: 50px;
  }

  img {
    z-index: 1;
  }
}

.mobile-router-header {
  padding-top: 5px;

  @media screen and (max-width: $min-width-iphone-8) {
    margin-left: 3rem;
  }

  @media screen and (max-width: $max-width-iphone-8) {
    margin-left: 3.2rem;
  }

  @media screen and (max-width: $max-width-ipad-pro-12) {
    margin-left: 3.5rem;
  }
}

.mobile-router-view {
  @media screen and (max-width: $min-width-iphone-8) {
    padding: 16px !important;
  }

  @media screen and (min-width: $min-width-iphone-8 + 1) and (max-width: $max-width-ipad-pro-12) {
    padding: 20px !important;
  }
}
</style>